<template>
  <v-container
    :key="nKey"
    v-if="oPermisos.priv_access == '1'"
    grid-list-xs
    class="pa-0 ma-0"
    fluid
  >
    <v-row class="no-gutters" v-show="bCargandoCampos">
      <v-col cols="12">
        <v-skeleton-loader
          type="table-heading, list-item-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
    <v-row class="no-gutters" v-show="!bCargandoCampos">
      <v-container fluid class="border-card mb-2 cont-expander-infocard" :class="bVerTodo ? 'h-completo':'h-minimo'">
        <div class="caja-desvanecido" :class="bVerTodo ? 'h-completo-desvanecido':'h-minimo-desvanecido'">
          <v-btn class="btn-vermas-infocard" @click="aMostrarCompleto" color="primary" dark dense small>
            <v-icon left>{{bVerTodo ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
            {{bVerTodo ? 'Ver Menos':'Ver Más'}}
          </v-btn>
        </div>
        <v-row
          v-show="campo.visible === '1'"
          v-for="(campo, index) in oDetalleFormulario.headers"
          :key="index"
          class="no-gutters border-b-gray py-1"
        >
          <v-col sm="4" md="4" lg="4" cols="12"
            class="py-0 ma-0"
          >
          <span class="text-medium text-primary ml-1">
            {{ campo.text }}
          </span>
          </v-col>
          <v-col sm="8" md="8" lg="8" cols="12"
            class="py-0 ma-0"
          >
          <p class="info-text-cardexpander">
            {{ onConsultarHeader(campo.value) }}
          </p>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row class="no-gutters" v-show="!bCargandoCampos">
      <v-container fluid>
        <v-row class="no-gutters">
          <v-container class="cont-shadown-rounded back-white pa-1" fluid>
            <v-row class="no-gutters">
              <v-col
                sm="12"
                cols="12"
                :md="oItem.cols"
                :lg="oItem.cols"
                :xl="oItem.cols"
                class="pa-1"
                v-for="(oItem, idx) in aFormItems"
                :key="'oItem-' + idx"
              >
                <component
                  v-model="oRegistro[oItem.nombre]"
                  v-show="oItem.Visible === '1' ? true : false"
                  :ref="`form-${oItem.nombre}`"
                  :is="oItem.tipo"
                  :titulo="oItem.label"
                  :obligatorio="oItem.obligatorio == '1' ? true : false"
                  :condicion="oItem.Condicion"
                  :inner="oItem.innerJoin"
                  :campo="oItem.nombre"
                  :editable="oItem.editable"
                  :campoFiltro="oItem.CampoFiltro"
                  :valorFiltro="oItem.ValorFiltro"
                  :sCampoModificaA="oItem.ModificaA"
                  :sTabla="sTabla"
                  :aParametros="aParametros"
                  @ModificaA="onModificarCampo"
                >
                </component>
              </v-col>
              <v-col cols="12" class="my-2">
                <v-divider></v-divider>
              </v-col>
              <v-col sm="12" cols="12" md="12" lg="12" xl="12" class="pa-1">
                <FormDinamicos
                  :key="'formDinamico'+keyGeneral"
                  v-if="bComponenteDinamico"
                  v-model="oRegistro.aRespuestaDinamico"
                  :ref="`form-dinamico`"
                  :obligatorio="''"
                  :condicion="''"
                  :inner="''"
                  :valorFiltro="sIdDinamico"
                  :sTabla="sTabla"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-row>
        <v-row class="no-gutters pa-2 mb-2">
          <div class="mx-auto">
            <v-btn color="btncolor" dark class="mx-1" @click="onCancelar"
              >{{$store.state.jsIdioma.oEquivalencias.btnCancelar}}
            </v-btn>
            <v-btn
              color="btncolor"
              dark
              class="mx-1"
              @click="onGuardarRegistro"
              :loading="bCargando"
              :class="{ 'btn-disabled': bCargando }"
              >{{$store.state.jsIdioma.oEquivalencias.btnGuardar}}
            </v-btn>
          </div>
        </v-row>
      </v-container>
      <ModalMensajeGeneral
        v-model="oModalMensaje.bModalVisible"
        :sMensaje="oModalMensaje.sMensaje"
        :nTipo="oModalMensaje.nTipo"
      />
    </v-row>
    <ErrorView v-model="bMostrarErrores" :aErrores="aErrores"></ErrorView>
  </v-container>
  <div class="no-acceso" v-else-if="!bCargando && oPermisos.priv_access == '0'">
    <v-sheet color="dark" class="cont-tabla">
      <v-skeleton-loader
        :loading="false"
        class="mx-auto"
        max-width="100%"
        type="table-heading, table-thead, table-tbody, table-tfoot"
      >
      </v-skeleton-loader>
      <div class="mensaje">
        <div class="cont-icon">
          <v-icon size="40px" class="icon">mdi-lock-off-outline</v-icon>
        </div>
        <div class="texto-mensaje pa-3">
          <span class="text-primary font-size-1">
            {{$store.state.jsIdioma.oEquivalencias.msgSinPermisosApp}}
          </span>
        </div>
      </div>
    </v-sheet>
  </div>
</template>
<script>
import selector from "@/components/Form/Componentes/FormSelect.vue";
import formlabel from "@/components/Form/Componentes/FormLabel.vue";
import numero from "@/components/Form/Componentes/FormNumero.vue";
import selectordependiente from "@/components/Form/Componentes/FormSelectFiltro.vue";
import FormMultiSelect from "@/components/Form/Componentes/FormMultiSelect.vue";
import FormTextArea from "@/components/Form/Componentes/FormTextArea.vue";
import FormTabla from "@/components/Form/Componentes/FormTabla.vue";
import FormMultipleRadioButton from "@/components/Form/Componentes/FormMultipleRadioButton.vue";
import axiosServices from "@/services/axiosServices.js";
import texto from "@/components/Form/Componentes/FormTexto.vue";
import textArea from "@/components/Form/Componentes/FormTextArea.vue";
import mxFunciones from "@/mixins/funciones.js";
import FormArchivos from "@/components/Form/Componentes/FormArchivos.vue";
import FormDinamicos from "@/components/Form/Componentes/FormDinamicos.vue";

import FormTexto from "@/components/Form/Componentes/FormTexto.vue";
import FormCorreo from "@/components/Form/Componentes/FormCorreo.vue";
import FormNumero from "@/components/Form/Componentes/FormNumero.vue";
import ErrorView from "@/components/ErrorView.vue";

import jsFormulario from "@/Utlidades/FormularioUtils.js";
import jsFecha from "@/Utlidades/Hora_Fecha.js";

export default {
  name: "FormGestionPqr",
  components: {
    selector,
    numero,
    selectordependiente,
    FormMultiSelect,
    FormMultipleRadioButton,
    FormTextArea,
    FormTabla,
    formlabel,
    texto,
    textArea,
    FormArchivos,
    FormDinamicos,
    FormTexto,
    FormCorreo,
    FormNumero,
    ErrorView,
  },
  mixins: [mxFunciones],
  props: {
    aParametros: {
      type: Array,
      default: () => [], // Listado de string que contiene parametros adicionales que se usan para realizar filtrado, este listado son campos existentes.
    },
    oData: {
      type: Object,
      default: () => {},
    },
    oDetalleFormulario: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return this.onIniciarData();
  },
  async mounted() {
    this.onIniciarVista();
  },
  methods: {
    onIniciarData() {
      return {
        oModalMensaje: {
          bModalVisible: false,
          sMensaje: "",
          nTipo: 2,
        },
        oRegistro: {},
        aFormItems: [],
        bCargando: false, // Esta de carga de información
        bCargandoCampos: false, // Cargando formularios
        sTituloGrid: "",
        sTabla: "PQR_Historicos_requerimiento",
        aPermisosPQR: [],
        sIdDinamico: "",
        bPermisoDinamico: false,
        aAnexosSubir: [],
        nKey: 0,
        bMostrarErrores: false,
        aErrores: [],
        nKeyActual: -1,
        oModalMensajeInput: {
          bModalMensaje: false,
          sMensaje: "",
          nTipo: 1,
          sNombreBotonConfirmar: "Eliminar",
        },
        bVerTodo: false,
        keyGeneral:0
      };
    },
    async onIniciarVista() {
      this.onCargarCampos();
    },
    async onCargarCampos() {
      this.bCargandoCampos = true;
      this.bCargando = true;
      let sParams = "sTable=" + this.sTabla;
      const aPermisos = await axiosServices.getConfiguration(
        "/pqr/permisos",
        true,
        sParams
      );
      this.aPermisosPQR = aPermisos.aData;

      const aCampos = await axiosServices.getConfiguration(
        "/formulario_campos",
        true,
        sParams
      );
      this.aFormItems = aCampos.aData;
      this.aFormItems[2].Visible = "0";
      this.aFormItems[3].Visible = "0";
      this.aFormItems[4].Visible = "0";
      this.aFormItems[3].obligatorio = "0";
      this.aFormItems[4].obligatorio = "0";
      this.aFormItems.forEach((oItem) => {
        if (
          oItem.Visible === "0" &&
          oItem.Condicion !== "" &&
          oItem.tipo === "texto"
        ) {
          const rex = /&&\w+&&/gi;
          if (oItem.Condicion.match(rex).length > 0) {
            this.oRegistro[oItem.nombre] = Object.prototype.hasOwnProperty.call(
              this.$store.state,
              oItem.Condicion.replaceAll("&&", "")
            )
              ? this.$store.state[oItem.Condicion.replaceAll("&&", "")]
              : oItem.Condicion;
          } else {
            this.oRegistro[oItem.nombre] = oItem.Condicion;
          }
        }
      });
      this.oRegistro.NombreDepartamento =  this.oData.Departamento_idDepartamento;
      if (this.oData.idPQR_SubTipo != null) {
        this.oRegistro.SubTipo = this.oData.idPQR_SubTipo;
        this.aFormItems[8].Visible = "0";
        this.onConsultarDinamico();
      }
      this.bCargandoCampos = false;
      this.bCargando = false;
    },
    onCancelar() {
      this.$emit('onCerrarFormulario')
    },
    onLimpiarDataFormulario() {
      this.aFormItems.forEach((elemento) => (elemento.Valor = ""));
    },
    onModificarCampo(sCampoModificado, sValor) {
      const nIndex = this.aFormItems.findIndex(
        (oItem) => oItem.nombre === sCampoModificado
      );
      if (this.aFormItems[nIndex].tipo === "selectordependiente") {
        this.aFormItems[nIndex].ValorFiltro = sValor;
      } else {
        this.oRegistro[this.aFormItems[nIndex].nombre] = sValor;
      }
      //actualizamos el componente con el ref
     this.$forceUpdate();
    },
    async onConsultarDinamico() {

      this.sIdDinamico = ''
      let oSubtipo = this.aPermisosPQR.aSubTipo.find(oItem => oItem.idPQR_SubTipo === this.oRegistro.SubTipo);

      if(oSubtipo!=undefined){
        this.sIdDinamico = oSubtipo.idFD_Formulario;
      }
      // await this.aPermisosPQR.aSubTipo.forEach((oItem) => {
      //   if (oItem.idPQR_SubTipo === this.oRegistro.SubTipo){
      //       this.sIdDinamico = oItem.idFD_Formulario;
      //   }else{
      //      this.sIdDinamico = ''
      //   }
      // });
      
      // S evalidan si tiene permisos
      const aItem = this.onFiltrarJsonLibre(
        this.aPermisosPQR.aPermisosFormulario,
        `$..[?(@.idPQR_Estado_Requerimiento==1 && @.idFD_Formulario=="${this.sIdDinamico}")]`
      );
      this.bPermisoDinamico = aItem.length === 0 ? false : true;
      const oPeticion = await axiosServices.getConfiguration(`/pqr/dinamicos/${this.oData.idRequerimiento}`, true, '' )
      const aData = oPeticion.aData  // estructura del dinamico
      try {
        if(aData.length !== 0){
          this.$refs['form-dinamico'].aDataDinamicos = aData
        }
      }catch(e) {
        e
      }
      
    },
    async onGuardarRegistro() {
      this.aErrores = [];
      this.bCargando = true;
      const oValidacion = jsFormulario.onValidarCamposObligatorios(
        this.aFormItems,
        this.oRegistro
      );

      if (oValidacion.bError) {
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje =
          "Se require todos los campos obligatorios diligenciados ";
        this.oModalMensaje.nTipo = 3;
        this.bCargando = false;
        return;
      }

      if (this.bComponenteDinamico) {
        this.$refs["form-dinamico"].onValidarFormulario();
        if (this.$refs["form-dinamico"].aErrores.length > 0) {
          this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
          this.oModalMensaje.sMensaje =
            "Se require todos los campos obligatorios diligenciados ";
          this.oModalMensaje.nTipo = 3;
          this.bCargando = false;
          return;
        }
      }

      if (
        Object.prototype.hasOwnProperty.call(this.oRegistro, "anexos") &&
        this.aAnexosSubir.length === 0
      ) {
        this.oRegistro.anexos.forEach((oItem) => {
          this.aAnexosSubir.push({ ...oItem });
        });
        this.oRegistro.anexos = this.onFormatearAnexos(this.oRegistro.anexos);
      }
      if (this.aAnexosSubir.length > 0) this.onSubirAnexos(this.aAnexosSubir);

      let sParams = "sTabla=" + this.sTabla;
      this.oRegistro.app = "PqrWeb";
      this.oRegistro.Fecha = jsFecha.getNow();
      this.oRegistro.idFormulario = this.sIdDinamico;
      this.oRegistro.idRequerimiento = this.oData.idRequerimiento;
      try {
        const axiosGuardar = await axiosServices.postConfiguration(
          "/pqr/gestionar",
          this.oRegistro,
          true,
          sParams
        );
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje = axiosGuardar.sMessage;
        this.bCargando = false;
        if (
          axiosGuardar.nStatusCode === 200 ||
          axiosGuardar.nStatusCode === 210
        ) {
          this.oModalMensaje.nTipo = 2;
          this.aAnexosSubir = [];
          this.$emit('onCerrarFormulario')
        } else {
          this.oModalMensaje.nTipo = 3;
        }
      } catch (e) {
        this.oModalMensaje.bModalVisible = !this.oModalMensaje.bModalVisible;
        this.oModalMensaje.sMensaje = "Estamos presentando problemas de red";
        this.oModalMensaje.nTipo = 3;
      }
    },
    onConsultarHeader(index) {
      return Object.prototype.hasOwnProperty.call(
        this.oDetalleFormulario.items,
        index
      )
        ? this.oDetalleFormulario.items[index]
        : "";
    },
    aMostrarCompleto(){
      this.bVerTodo =! this.bVerTodo
    }
  },
  computed: {
    onMostrarTransferencia() {
      if (Object.prototype.hasOwnProperty.call(this.oRegistro, "Estado")) {
        return this.oRegistro.Estado === "5" ? true : false;
      } else {
        return false;
      }
    },
    onSubTipo() {
      return this.oRegistro.hasOwnProperty("SubTipo") ? this.oRegistro.SubTipo : ''
    },
    bComponenteDinamico() {
      return (
        this.bPermisoDinamico &&
        this.oRegistro.SubTipo &&
        this.sIdDinamico
      );
    },
  },
  watch: {
    onMostrarTransferencia() {
      if (this.onMostrarTransferencia) {
        this.aFormItems[2].Visible = "1";
        this.aFormItems[3].Visible = "1";
        this.aFormItems[4].Visible = "1";
        this.aFormItems[3].obligatorio = "1";
        this.aFormItems[4].obligatorio = "1";
      } else {
        this.aFormItems[2].Visible = "0";
        this.aFormItems[3].Visible = "0";
        this.aFormItems[4].Visible = "0";
        this.aFormItems[3].obligatorio = "0";
        this.aFormItems[4].obligatorio = "0";
      }
    },
    onSubTipo() {
      if (this.onSubTipo !== "") {
        this.onConsultarDinamico();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.mdlHeadForms {
  font-size: 0.9em;
}
.cont-expander-infocard{
  position: relative;
}
.caja-desvanecido{
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 1;
  width: 100%;
  display: flex;
  justify-content: end;
  align-items:flex-end;
  .btn-vermas-infocard{
    margin: 0px 5px 5px 0px;
  }
}
.h-minimo-desvanecido{
  background: rgb(255,255,255);
  background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,1) 12%, rgba(255,255,255,0.87718837535014) 33%, rgba(255,255,255,0) 100%);
}
.h-completo-desvanecido{
  background: none;
}
.h-completo{
  height: auto;
  overflow: auto;
  padding: 10px 10px 50px 10px!important;
  .caja-desvanecido{
    height: 40px;
    border-top: solid #e3e3e3 1px;
  }
}
.h-minimo{
  height: 200px;
  overflow: hidden;
  padding: 10px 10px 10px 10px!important;
  .caja-desvanecido{
    height: 80px;
    border-top: none;
  }
}
.info-text-cardexpander{
  font-size: 0.95em;
  line-height: 1.1em;
  margin: 0px;
  padding: 0px;
}
</style>
